module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0108.jpg?v=79796437";